import React, { useState, useContext } from 'react';
import { CategoryManagementContext } from 'contexts/CategoryManagementContext';
import {
	Wrapper,
	KpiGridContainer,
	Ribbon,
	RibbonText,
	TableWrapper,
	CardTypesWrapper,
	CardTypeOptionWrapper,
	CardTypeOptionButton,
	IconWrapper,
	Heading,
	ContentLoader,
	DateRangeWrapper,
	SourceableTotalSpendOptionWrapper,
	DirectIndirectOptionsWrapper,
	TaxonomyTypeOptionWrapper,
} from './Insights.styles';
import {
	ApButtonIcon,
	ApButtonMain,
	ApIcon,
	ApLoaderDefault,
	ApLoaderText,
	ApSimpleDropdown,
	ApToggleSwitch,
	colors,
} from '@alixpartners/ui-components';
import { allOption } from 'CategoryManagement/utils';
import ToggleSidebar from 'CategoryManagement/Components/ToggleSidebar/ToggleSidebar';
import { AgGridReact } from '@ag-grid-community/react';
import { AllModules } from '@ag-grid-enterprise/all-modules';
import InsightsSettings from './InsightsSettings/InsightsSettings';
import MonthPicker from 'Settings/FirstUsageSettings/MonthPicker';
import { isUndefined } from 'lodash';
import KpiList from 'CategoryManagement/Components/KpiList/KpiList';
import CardsWrapper from './CardsWrapper';
import CategorySidebarContent from 'CategoryManagement/Components/CategorySidebarContent/CategorySidebarContent';
import { CategoryInsightsSettingsContext } from 'contexts/CategoryInsightsSettingsContext';
import {
	DirectIndirectOptions,
	DirectTaxonomyTypeOptions,
	IndirectTaxonomyTypeOptions,
	SourceableTotalSpendOptions,
} from '../utils';
import { NoDataWrapper } from 'Pmi/HeroChartContainer/styles';
import NoData from 'CategoryManagement/NoData';

const ROW_HEIGHT = 30;

const Insights = () => {
	const {
		isFetching,
		currentSelectCategory,
		dateRangeData,
		handleDateRangeChange,
		isDirect,
		isSourceable,
		taxonomyType,
		handleSourceableTotalSpendChange,
		handleDirectIndirectChange,
		handleTaxonomyTypeChange,
		kpi,
	} = useContext(CategoryManagementContext);
	const {
		loading: isSettingsFetching,
		cardTypes,
		cardsSettings,
		isCardsSettingsSaving,
		handleSaveSettings,
		handleSaveCardSettings,
		handleToggleCard,
		handleCardTypeFilter,
	} = useContext(CategoryInsightsSettingsContext);
	const [isCategorySidebar, setIsCategorySidebar] = useState(false);
	const [isFilterSidebar, setIsFilterSidebar] = useState(false);
	const [isSettingSidebar, setIsSettingSidebar] = useState(false);
	const [isInsightSetting, setIsInsightSetting] = useState(false);
	const { data } = kpi;
	const columnDefs = [
		{
			field: 'cardName',
			headerName: 'Card Name',
			minWidth: 300,
			width: 300,
			maxWidth: 300,
		},
		{
			field: 'isVisible',
			headerName: 'Action',
			minWidth: 120,
			width: 120,
			maxWidth: 120,
			cellRendererFramework: params => (
				<>
					<ApToggleSwitch
						color={colors.green100}
						checked={params.data.isVisible}
						onChange={() => handleToggleCard(params.data.id)}
					/>
				</>
			),
		},
	];

	const getGridOptions = () => {
		return {
			modules: AllModules,
			defaultColDef: {
				suppressMenu: true,
				flex: 1,
				comparator: () => 0,
			},
			rowData: cardsSettings,
			rowHeight: ROW_HEIGHT,
			columnDefs,
			suppressCopyRowsToClipboard: true,
			suppressScrollOnNewData: true,
			suppressRowDrag: true,
			suppressRowClickSelection: true,
			suppressCellSelection: true,
			suppressCsvExport: true,
			suppressExcelExport: true,
			suppressContextMenu: true,
			suppressMultiSort: true,
			applyColumnDefOrder: true,
			domLayout: 'autoHeight',
		};
	};

	const onSaveInsightsSettings = value => {
		if (value) {
			handleSaveSettings(value);
		} else {
			handleSaveSettings(value);
			setIsInsightSetting(value);
		}
	};
	return (
		<Wrapper>
			<Ribbon>
				<div>
					<ApButtonIcon
						title="Add Category"
						iconName="add"
						iconProps={{ iconColor: colors.grey8 }}
						onClick={() => setIsCategorySidebar(true)}
					/>
				</div>
				<RibbonText>
					{currentSelectCategory.categoryName === allOption.id ? (
						'Category - All'
					) : (
						<>
							L{decodeURI(currentSelectCategory.categoryName).split('/')
								.length - 2}
							Category -{' '}
							{decodeURIComponent(
								decodeURI(currentSelectCategory.categoryName).split('/')[
									decodeURI(currentSelectCategory.categoryName).split('/')
										.length - 2
								]
							)}
						</>
					)}
				</RibbonText>
				<DirectIndirectOptionsWrapper>
					<ApSimpleDropdown
						options={DirectIndirectOptions}
						selected={
							DirectIndirectOptions.filter(x => x.value === isDirect)?.[0]
						}
						onChange={e => handleDirectIndirectChange(e.value)}
					/>
				</DirectIndirectOptionsWrapper>
				<SourceableTotalSpendOptionWrapper>
					<ApSimpleDropdown
						options={SourceableTotalSpendOptions}
						selected={
							SourceableTotalSpendOptions.filter(
								x => x.value === isSourceable
							)?.[0]
						}
						onChange={e => handleSourceableTotalSpendChange(e.value)}
					/>
				</SourceableTotalSpendOptionWrapper>
				<TaxonomyTypeOptionWrapper>
					<ApSimpleDropdown
						options={
							isDirect === false
								? DirectTaxonomyTypeOptions
								: IndirectTaxonomyTypeOptions
						}
						selected={
							isDirect === false
								? DirectTaxonomyTypeOptions[0]
								: IndirectTaxonomyTypeOptions.filter(
										x => x.value === taxonomyType
								  )
						}
						onChange={e => handleTaxonomyTypeChange(e.value)}
					/>
				</TaxonomyTypeOptionWrapper>
				<DateRangeWrapper>
					{!isUndefined(dateRangeData) && (
						<MonthPicker
							srcRange={dateRangeData.srcRange}
							stateRange={dateRangeData.stateRange}
							onConfirm={handleDateRangeChange}
						/>
					)}
				</DateRangeWrapper>
				<div>
					<ApButtonIcon
						title={`Hide/Show KPI's`}
						iconName="baseline_tune"
						onClick={() => setIsSettingSidebar(true)}
					/>
				</div>
				<div>
					<ApButtonIcon
						title={`Filter KPI's`}
						iconName="filter_outlined"
						onClick={() => setIsFilterSidebar(true)}
					/>
				</div>
				<div>
					<ApButtonIcon
						title={`Insights Settings`}
						iconName="settings"
						onClick={() => setIsInsightSetting(true)}
					/>
				</div>
			</Ribbon>

			{isFetching || isSettingsFetching ? (
				<ContentLoader>
					<ApLoaderDefault loaderText={() => <ApLoaderText />} />
				</ContentLoader>
			) : data.totalSpend === '$0.00' ? (
				<NoDataWrapper>
					<NoData
						title="No data available for this combination of filters"
						msg="Please try to  change the filter options"
						onResetClick={() => console.log('aaaaaa')}
					/>
				</NoDataWrapper>
			) : (
				<>
					<KpiGridContainer>
						<KpiList />
					</KpiGridContainer>

					{cardsSettings.length > 0 && (
						<CardsWrapper cardsOption={cardsSettings} />
					)}
				</>
			)}

			<ToggleSidebar
				key={0}
				id={0}
				name={'category'}
				heading={'Categories'}
				show={isCategorySidebar}
				handleClose={setIsCategorySidebar}
				width={'24%'}
				toRight={false}
			>
				<CategorySidebarContent />
			</ToggleSidebar>

			<ToggleSidebar
				key={1}
				id={1}
				name={'settings'}
				heading={'Settings'}
				show={isSettingSidebar}
				handleClose={setIsSettingSidebar}
				width={'32%'}
				toRight={true}
			>
				{isCardsSettingsSaving ? (
					<ApLoaderDefault loaderText={() => <ApLoaderText />} />
				) : (
					<TableWrapper>
						<div className="ag-theme-balham">
							<AgGridReact {...getGridOptions()} />
						</div>
						<div style={{ padding: '10px 0 10px 10px' }}>
							<ApButtonMain
								title="Save Settings"
								onClick={handleSaveCardSettings}
							>
								Save
							</ApButtonMain>
						</div>
					</TableWrapper>
				)}
			</ToggleSidebar>

			<ToggleSidebar
				key={2}
				id={2}
				name={'filter'}
				heading={'Filter Tiles/Cards'}
				show={isFilterSidebar}
				handleClose={setIsFilterSidebar}
				width={'20%'}
				toRight={true}
			>
				{isCardsSettingsSaving ? (
					<ApLoaderDefault loaderText={() => <ApLoaderText />} />
				) : (
					<>
						<CardTypesWrapper>
							{cardTypes.map((item, index) => {
								const {
									id,
									isSelected,
									label,
									value,
									isMaterial,
									iconName,
								} = item;
								return (
									<CardTypeOptionWrapper key={index} isSelected={isSelected}>
										<CardTypeOptionButton
											onClick={() =>
												handleCardTypeFilter(id, value, isSelected)
											}
										>
											<IconWrapper>
												<ApIcon
													material={isMaterial}
													iconName={iconName}
													iconColor={colors.black}
												/>
											</IconWrapper>
											<Heading>{label}</Heading>
										</CardTypeOptionButton>
									</CardTypeOptionWrapper>
								);
							})}
						</CardTypesWrapper>
						<div style={{ padding: '10px 0 10px 10px' }}>
							<ApButtonMain
								title="Save Settings"
								onClick={handleSaveCardSettings}
							>
								Save
							</ApButtonMain>
						</div>
					</>
				)}
			</ToggleSidebar>

			<ToggleSidebar
				key={3}
				id={3}
				name={'insight_settings'}
				heading={'Insights Settings'}
				show={isInsightSetting}
				handleClose={setIsInsightSetting}
				width={'40%'}
				toRight={true}
			>
				<InsightsSettings onSaveSettings={onSaveInsightsSettings} />
			</ToggleSidebar>
		</Wrapper>
	);
};

export default Insights;
